module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAtklEQVQ4y2NgGBwgyfg/WRiXAawpRhiK2bCIYTWAK80QztYt1gJjGJ833YCwAWqF2mBaHUjf284OxupQMe0iLcIGrFkiCGcnd8iDMYy/dxUvYQM+7GP+71GniuHfqFbF/5/3MxE2YN1Sgf8/DzH+b58m8d+sXOO/ZYXG/94Z4v//HGYEyxE0QKtI+//bvSz//x9hQMEgMZAcUdEonaP3fzUwLJ7vZgVjEBskRnQ6oDghkW7AkAYAPEMNBQFMQAQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MR.png
// module id = 1214
// module chunks = 0